var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataTableservices!=null && _vm.dataTableservices.remark!=null)?_c('div',[_c('div',{staticClass:"show-content show-content-remark"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12"},[_c('p',{staticClass:"text-h"},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataTableservices.remark.remarks)}})])])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/service/Remark.vue?vue&type=template&id=8a9bcce6&scoped=true&
// module id = null
// module chunks = 